const ExploreAnalysisCreate = () =>
  import("@/components/Explore/ExploreAnalysis/ExploreAnalysisCreate");
const ExploreAnalysisEdit = () =>
  import("@/components/Explore/ExploreAnalysis/ExploreAnalysisEdit");
const ExploreAnalysisIndex = () =>
  import("@/components/Explore/ExploreAnalysis/ExploreAnalysisIndex");
const ExploreAnalysisView = () =>
  import("@/components/Explore/ExploreAnalysis/ExploreAnalysisView");
const ExploreFields = () =>
  import("@/components/Explore/ExploreFields/ExploreFields");
const ExploreDiscover = () =>
  import("@/components/Explore/ExploreDiscover/ExploreDiscover");
const ExploreSettings = () =>
  import("@/components/Explore/ExploreSettings/ExploreSettings");
const Export = () =>
  import("@/components/Explore/ExploreSettings/Export");
const ExploreStory = () =>
  import("@/components/Explore/ExploreStory/ExploreStory");
const ExploreFilters = () =>
  import("@/components/Explore/ExploreFilters/ExploreFilters");

const routes = [
  {
    name: "ExploreFields",
    path: "/explore/fields",
    component: ExploreFields,
    meta: {
      title: "Fields view",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreDiscover",
    path: "/explore/discover",
    component: ExploreDiscover,
    meta: {
      title: "Discover view",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreStory",
    path: "/explore/story",
    component: ExploreStory,
    meta: {
      title: "Story view",
      sidebar: false,
      explore: true,
      panels: true
    }
  },
  {
    name: "ExploreAnalysisIndex",
    path: "/explore/analysis",
    component: ExploreAnalysisIndex,
    meta: {
      title: "Analysis",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreAnalysisCreate",
    path: "/explore/analysis/create",
    component: ExploreAnalysisCreate,
    meta: {
      title: "Create analysis",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreAnalysisEdit",
    path: "/explore/analysis/:id/edit",
    component: ExploreAnalysisEdit,
    meta: {
      title: "Edit analysis",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreAnalysisView",
    path: "/explore/analysis/:id",
    component: ExploreAnalysisView,
    meta: {
      title: "View analysis",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreSettings",
    path: "/explore/settings",
    component: ExploreSettings,
    meta: {
      title: "Settings",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "Export",
    path: "/explore/export",
    component: Export,
    meta: {
      title: "Export",
      sidebar: false,
      explore: true
    }
  },
  {
    name: "ExploreFilters",
    path: "/explore/filters",
    component: ExploreFilters,
    meta: {
      title: "Filters",
      sidebar: false,
      explore: true
    }
  }
];

export default routes;
